import React, { useRef, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { notificationService } from "../../../services/notificationService";
import { notificationPaths } from '../../../data/EndorsementConstants';

const NotificationPopUp = ({ handleClosePopup, userType }) => {
    const popupRef = useRef(null);
    const [notifications, setNotifications] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNotifications = async () => {
            try {
                const response = await notificationService.getAllNotifications(1, 3); // Fetch the top 3 notifications
                setNotifications(response?.data?.data?.data);
            } catch (error) {
                console.error("Error fetching notifications: ", error);
            }
        };

        fetchNotifications();

        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                handleClosePopup();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClosePopup]);

    const handleNavigation = (link) => {
        navigate(link); // Navigates to the given link
        handleClosePopup(); // Closes the popup after navigation
    };

    return (
        <div ref={popupRef}>
            <ul className="notification-list mb-0">
                {notifications.length > 0 ? (
                    notifications.map((notification, index) => {
                        return (
                            <li key={index}>
                                <div className="notification-title">
                                    {notificationPaths[notification.type] ? (
                                        <>
                                            {notification.payload !== "{}" ? (
                                                <span
                                                    onClick={() => {
                                                        const currentPath = window.location.pathname;
                                                        const targetPath =
                                                            notification.type === 5
                                                                ? JSON.parse(notification.payload)?.isRejected
                                                                    ? "/dashboard"
                                                                    : "/certifications"
                                                                : typeof notificationPaths[notification.type] === "function"
                                                                    ? notificationPaths[notification.type](notification)
                                                                    : notificationPaths[notification.type];

                                                        if (currentPath === targetPath) {
                                                            window.location.reload(); // Reload if the same path
                                                        } else {
                                                            handleNavigation(targetPath); // Navigate if the path is different
                                                        }
                                                    }}
                                                    style={{ color: "#29348F", cursor: "pointer" }}
                                                >
                                                    {notification.title}
                                                </span>
                                            ) : (
                                                <span
                                                    onClick={() => {
                                                        const currentPath = window.location.pathname;
                                                        const targetPath = "/dashboard";

                                                        if (currentPath === targetPath) {
                                                            window.location.reload(); // Reload if the same path
                                                        } else {
                                                            handleNavigation(targetPath); // Navigate if the path is different
                                                        }
                                                    }}
                                                    style={{ color: "#29348F", cursor: "pointer" }}
                                                >
                                                    {notification.title}
                                                </span>
                                            )}

                                        </>
                                    ) : (
                                        <span>{notification.title}</span>
                                    )}
                                </div>
                                <div className="notification-item-subtitle">
                                    {notification.body}
                                </div>
                            </li>
                        )
                    })
                ) : (
                    <li>No notifications available</li>
                )}
            </ul>
            <div className="view-all mt-0">
                <Link
                    to="#"
                    className="text-decoration-underline"
                    onClick={() => {
                        handleNavigation(userType === 3 ? "/atp/dashboard/notifications" : "/dashboard/notifications");
                    }}
                >
                    View All
                </Link>
            </div>
        </div>
    );
};

export default NotificationPopUp;
